export default "__VITE_ASSET__BzUcI$fY__"